import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLicensingPaymentBreakdownCalculations } from '../../../../hooks/useLicensingPaymentBreakdownCalculations'
import {
  BreakdownLedgerForPDF,
  BreakdownLedgerForPDFStyles,
  BreakDownLedgerPDFVariants,
} from './BreakdownLedgerForPDF'

type SemesterOneSubtotalBreakdownProps = Pick<
  ReturnType<typeof useLicensingPaymentBreakdownCalculations>,
  'semester1AdditionalStudent' | 'semester1FirstStudent' | 'semester1Subtotal'
> &
  BreakdownLedgerForPDFStyles & {
    isChallenge: boolean
    subHeaderLabel?: string
    displaySubTotalLabel?: boolean
  }

export const SemesterOneSubtotalBreakdown: React.FC<
  SemesterOneSubtotalBreakdownProps
> = ({
  isChallenge,
  semester1AdditionalStudent,
  semester1FirstStudent,
  semester1Subtotal,
  subHeaderCellCssProps,
  subHeaderRowCssProps,
  bodyCellCssProps,
  subTotalCellCssProps,
  paymentHeaderCellCssProps,
  nestedDescription,
  subHeaderLabel,
  displaySubTotalLabel,
}) => {
  const { t } = useTranslation()

  const firstSemesterLicensingTuitionLabel = t(
    'Licensing.Table.Breakdown.Header.FirstSemesterLicensingTuition',
    '1st Semester Licensing Fee - Tuition'
  )

  if (isChallenge) {
    return (
      <BreakdownLedgerForPDF
        variant={BreakDownLedgerPDFVariants.Normal}
        headerLabel={subHeaderLabel || firstSemesterLicensingTuitionLabel}
        firstStudent={semester1FirstStudent}
        additionalStudent={semester1AdditionalStudent}
        subtotal={semester1Subtotal}
        subHeaderCellCssProps={subHeaderCellCssProps}
        subHeaderRowCssProps={subHeaderRowCssProps}
        bodyCellCssProps={bodyCellCssProps}
        subTotalCellCssProps={subTotalCellCssProps}
        paymentHeaderCellCssProps={paymentHeaderCellCssProps}
        nestedDescription={nestedDescription}
        displaySubTotalLabel={displaySubTotalLabel}
      />
    )
  }

  return <></>
}
